import styled from 'styled-components';
import { theme } from '../../styles/themes/default';

export const Container = styled.div`
  .header {
    display: flex;
    justify-content: space-between;
    margin-bottom: ${theme.spacings[4]};

    div {
      display: flex;
      justify-content: space-between;
      button {
        width: 24rem;
        margin-left: ${theme.spacings[1]};
      }
      a {
        text-decoration: none;
        button {
          width: 20rem;
        }
      }
    }
  }

  .search-filter-bar {
    display: flex;
    justify-content: space-between;
    margin-bottom: ${theme.spacings[1.5]};

    input {
      width: 40rem;
    }
  }

  .badge-cell {
    width: 3rem;
  }
`;

export const StyledForm = styled.form`
  padding-bottom: 10rem;
  > div {
    margin-bottom: ${theme.spacings[2]};
  }
  .buttons-container {
    display: flex;
    button + button {
      margin-left: ${theme.spacings[2]};
    }
  }
  .info {
    margin-top: 0.4rem;
    ul {
      background: ${theme.colors.neutral.white};
      border: 0.1rem solid ${theme.colors.grey[200]};
      border-radius: 0.4rem;
      list-style: none;
      font-size: ${theme.fonts['x-small']};
      line-height: ${theme.fonts['large']};
      padding: ${theme.spacings[1.5]} ${theme.spacings[1]};
      max-height: 14rem;
      overflow-y: scroll;
      li {
        padding: ${theme.spacings[0.5]} ${theme.spacings[1]};
        border-radius: 0.4rem;
        &:nth-child(odd) {
          background: ${theme.colors.grey[50]};
        }
      }
    }
  }
  .tabs {
    display: flex;
    .tab {
      color: ${theme.colors.grey[400]};
      font-weight: bold;
      margin-right: ${theme.spacings[5]};
      cursor: pointer;
      position: relative;
      background: none;
      border: 0;
      &.active {
        color: ${theme.colors.grey[700]};
      }
      &.active::after {
        content: '';
        width: 3.2rem;
        border: 0.15rem solid ${theme.colors.blue[600]};
        position: absolute;
        bottom: -1.8rem;
        left: 0;
      }
    }
  }

  .switch {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    p {
      font-weight: bold;
      margin-left: ${theme.spacings[1]};
    }
    div {
      width: auto;
    }
    label {
      display: none;
    }
  }
`;
